import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ContactFormComponent } from './contact-form.component';
import { PageTitleComponent } from '@awo-care/shared-ui';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-contact',
  imports: [ContactFormComponent, PageTitleComponent, RouterLink],
  template: `
    <app-page-title
      title="Kontaktieren Sie uns"
      [centered]="true"
      i18n-title="@@home.contact-form.title"
    />
    <div class="faq-link">
      <a routerLink="/faq" i18n="@@contact.faqLink">
        Schauen Sie zuerst in unsere häufigen Fragen — vielleicht ist die
        Antwort schon dabei.
      </a>
    </div>
    @if (showAbsenceNotice) {
    <div class="absence-notice" role="status" data-testid="support-absence-notice">
      <p i18n="@@contact.absenceNotice.greeting">Liebe AWO-Care-Nutzer,</p>
      <p i18n="@@contact.absenceNotice.body">
        in der Zeit vom 05.10.–09.10.2026 ist der Support nur eingeschränkt
        erreichbar. Ab dem 12.10. werden alle Ihre Anfragen in der Reihenfolge
        des Eingangs bearbeitet.
      </p>
      <p i18n="@@contact.absenceNotice.closing">
        Wir bitten um Ihr Verständnis und wünschen eine schöne Ferienzeit.
      </p>
    </div>
    }
    <app-contact-form data-testid="contact-form-host" />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 3rem 2rem;
      }

      .faq-link {
        text-align: center;
        margin-bottom: 1.5rem;
        max-width: 600px;
      }

      .faq-link a {
        color: var(--theme-accent-text, #08acd3);
        font-size: 0.95rem;
        text-decoration: underline;
      }

      .absence-notice {
        max-width: 600px;
        margin-bottom: 1.5rem;
        padding: 1rem 1.25rem;
        border-radius: 8px;
        border: 1px solid var(--theme-accent);
        background: color-mix(in srgb, var(--theme-accent) 8%, transparent);
        font-size: 0.95rem;
        line-height: 1.5;
      }

      .absence-notice p {
        margin: 0 0 0.5rem;
      }

      .absence-notice p:last-child {
        margin-bottom: 0;
      }

      @media (max-width: 768px) {
        :host {
          padding: 2rem 1rem;
        }
      }
    `,
  ],
})
export class ContactComponent {
  /**
   * Befristeter Support-Abwesenheitshinweis (Urlaub Teamleitung, Issues #737, #1195).
   * Wird automatisch ab dem 12.10.2026 ausgeblendet — kein Deploy zum Entfernen
   * nötig. SSR-sicher: nutzt nur Server-/Client-Zeit, keine Browser-Globals.
   */
  private static readonly ABSENCE_NOTICE_END = new Date('2026-10-12T00:00:00+02:00');

  readonly showAbsenceNotice = new Date() < ContactComponent.ABSENCE_NOTICE_END;
}
